import { useQuery } from '@tanstack/react-query';
import { dashboardApi } from '../services/api';
import { useAuth } from '../contexts/AuthContext';
import { SUB_BU_QUERY_OPTIONS } from '../constants/QueryConstants';

/**
 * Fetches Sub-BU options for the given Business Unit IDs/names via /dashboard/sub-bus.
 * Cache is keyed by user id and selected BUs so multiple consumers share the same result.
 * Returns empty list and no loading when businessUnits is empty or undefined.
 */
export function useSubBusOptions(businessUnits: string[] | undefined) {
  const { user } = useAuth();
  const enabled = !!(businessUnits && businessUnits.length > 0);

  const result = useQuery({
    queryKey: ['sub-bu-options', user?.id, businessUnits],
    queryFn: async () => {
      if (!businessUnits || businessUnits.length === 0) return [];
      return dashboardApi.getSubBusByBusinessUnits(businessUnits);
    },
    enabled,
    ...SUB_BU_QUERY_OPTIONS,
  });

  return {
    data: result.data ?? [],
    isLoading: result.isLoading,
    error: result.error,
    refetch: result.refetch,
  };
}
